define([
	'internal_util/Util',
	'lib/jquery',
	'lib/bootstrap/dropdown' // doesn't export
], function (
	Util,
	jQuery
) {
	'use strict';

	/**
	 * ControlBarView class
	 */
	return function (id) {
		var _view;

		_view = (function () {
					var $view = jQuery(
							"<div class='skIdS_control-bar-container'>" +
								"<div class='skIdS_control-bar-checkbox-container'></div>" +
								"<div class='skIdS_control-bar-button-container'>" +
									"<div class='skIdS_control-bar-left'></div>" +
									"<div class='skIdS_control-bar-middle'></div>" +
									"<div class='skIdS_control-bar-right'></div>" +
								"</div>" +
							"</div>");

					if (Util.isValidString(id)) {
						$view.attr('id', id);
					}

					$view.find('.skIdS_control-bar-checkbox-container').hide();
					$view.find('.skIdS_control-bar-middle').hide();

					return $view;
				})();


		// private methods

		function getButtonContainer(position) {
			var $container;

			switch (position) {
			case 0:
				$container = _view.find('.skIdS_control-bar-left');
				break;
			case 1:
				$container = _view.find('.skIdS_control-bar-middle');
				break;
			case 2:
			default:
				$container = _view.find('.skIdS_control-bar-right');
			}

			if (!$container.is(':visible')) {
				$container.css('display', '');
			}

			return $container;
		}


		// public methods

		this.get = function () {
			return _view;
		};

		this.setId = function (id) {
			if (Util.isValidString(id)) {
				_view.attr('id', id);
			}
		};

		this.addButton = function (title, callback, position) {
			var $button = jQuery('<button type="button" class="skIdS_control-bar-button btn btn-default">' + title + '</button>');

			$button.on('click', callback);

			getButtonContainer(position).append($button);

			return $button;
		};

		this.addButtonDropup = function (titles, callbacks, position) {
			var $buttonDropup = jQuery(
					'<div class="skIdS_control-bar-button-dropup btn-group dropup">' +
						'<button type="button" class="btn btn-default"></button>' +
						'<button type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-expanded="false">' +
							'<span class="caret"></span>' +
							'<span class="sr-only">Toggle Dropdown</span>' +
						'</button>' +
						'<ul class="dropdown-menu" role="menu"></ul>' +
					'</div>'),
				$button;

			if (!Util.isArray(titles) || !Util.isArray(callbacks) || titles.length !== callbacks.length) {
				return;
			}

			for (var i = 0; i < titles.length; i++) {
				if (i === 0) {
					$button = $buttonDropup.children().first();

					$button.html(titles[i]);
				} else {
					$button = jQuery('<li><a href="javascript:;">' + titles[i] + '</a></li>');

					$buttonDropup.children().last().append($button);
				}

				$button.on('click', (function (callback) {
					return function (event) {
						event.preventDefault();

						Util.callCallbacks(callback);
					};
				})(callbacks[i]));
			}

			getButtonContainer(position).append($buttonDropup);

			return $buttonDropup;
		};

		this.addCheckBox = function (title, callback) {
			var $checkboxContainer = jQuery(
					'<div class="skIdS_control-bar-checkbox">' +
						'<input type="checkbox" /><label>&nbsp;' + title + '</label>' +
					'</div>'),
				$container = _view.find('.skIdS_control-bar-checkbox-container');

			$checkboxContainer.on('click', function (event) {
					var $checkBox = $checkboxContainer.children('input');

					if (event.target !== $checkBox[0]) {
						$checkBox.prop('checked', !$checkBox.is(':checked'));
					}

					Util.callCallbacks(callback, $checkBox.is(':checked'));
				});

			if (!$container.is(':visible')) {
				$container.css('display', '');
			}

			$container.append($checkboxContainer);

			return $checkboxContainer;
		};
	};
});


//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/view/ControlBarView.js
// module id = 14
// module chunks = 1